import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full  grid grid-cols-1 xl:grid-cols-2 gap-6 xl:gap-10"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">
            2020 - 2025
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">
            Educational Qualification
          </h2>
        </div>
        <div
          className="mt-6 lgl:mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10"
          data-aos="fade-right"
        >
          <ResumeCard
            title="BSc. Engineering"
            subTitle="Jashore University of Science and Technology"
            result="Completed"
            des="Subject: Computer Science and Engineering"
            cgpa="3.54"
            outOf='4.00'
          />
          <ResumeCard
            title="Higher Secondery School Certificate"
            subTitle="Shaheed Bulbul Govt. College, Pabna"
            result="Completed"
            des="Subject: Science"
            cgpa="4.50"
            outOf='5.00'
          />
        </div>
      </div>

      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2024</p>
          <h2 className="text-3xl md:text-4xl font-bold">Certificates</h2>
        </div>
        <div
          className="mt-6 lgl:mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10"
          data-aos="fade-left"
        >
          <ResumeCard
            title="Complete Web Development Course With Jhankar Mahbub"
            subTitle="Progamming Hero - ( 01/07/2023 - 20/01/2024 )"
            result="Online"
            des={`I completed the "Complete Web Development Course with Jhankar Mahbub" at Programming Hero, where I learned frontend technologies and the MERN stack, gaining skills in full-stack web development.`}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Education;
